import { Component } from '@verndale/core';
import Swiper from 'swiper';
import debounce from 'lodash/debounce';
import loadNews from './LoadNews';
import { BREAKPOINT } from '../../constants';

class News extends Component {
  setupDefaults() {
    this.dom = {
      $window: $(window),
      $slider: this.$el.find('.news__slider'),
      $list: this.$el.find('.news__list'),
      $pagination: this.$el.find('.swiper-pagination')
    };
    this.width = document.body.clientWidth;

    const url = this.$el.data('url');

    if (url) {
      loadNews(url, this.renderItem).then(news => {
        this.dom.$list.html(news);
        this.dom.$items = this.$el.find('.news__item');
        //this.initSwiper();
      });
    } else {
      //this.initSwiper();
    }
  }

  addListeners() {
    this.dom.$window.on('resize', debounce(::this.handleResize, 300));
  }

  renderItem(article) {
    return `<div class="news__item">${article}</div>`;
  }

  handleResize() {
    if (this.width !== document.body.clientWidth) {
      this.width = document.body.clientWidth;
      //this.initSwiper();
    }
  }

  initSwiper() {
    if (document.body.clientWidth >= BREAKPOINT.tablet) {
      if (this.swiper) {
        this.swiper.destroy();
        this.removeStructure();
        this.swiper = null;
      }
      return;
    }
    if (this.swiper) {
      this.swiper.update();
      return;
    }
    this.createStructure();
    this.swiper = new Swiper('.news__slider', {
      slidesPerView: 'auto',
      loop: true,
      pagination: {
        el: '.swiper-pagination'
      }
    });
  }

  createStructure() {
    this.dom.$slider.addClass('swiper-container');
    this.dom.$list.addClass('swiper-wrapper');
    this.dom.$items.addClass('swiper-slide');
  }

  removeStructure() {
    this.dom.$slider.removeClass('swiper-container');
    this.dom.$list.removeClass('swiper-wrapper');
    this.dom.$items
      .removeClass('swiper-slide')
      .removeClass('swiper-slide-duplicate-active')
      .removeClass('swiper-slide-duplicate-next')
      .removeClass('swiper-slide-duplicate-prev');
    this.dom.$pagination.empty();
  }
}

export default News;
